export const GUIDE_NAME =
  "The Hitchhiker's Guide to the Cataclysm: Bright Nights";
